import { Search, SearchIconWrapper, StyledInputBase } from 'components';
import { SearchIcon, CloseOutlinedIcon } from 'components/icons';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { searchContact } from 'containers/pages/contacts/libs';
import { array, func, string } from 'prop-types';

/**
 * @component ContactSearch
 * @desc Contact search component.
 * @param {Object} props - The component props.
 * @param {string} props.searchInput - The current search input value.
 * @param {Contact[]} props.contacts - The array of contacts to search within.
 * @param {function} props.onSearchInput - The callback function to handle search input changes.
 * @param {function} props.onSearch - The callback function to perform the search.
 * @param {function} props.onReset - The callback function to reset the search.
 * @returns {JSX.Element} The ContactSearch component.
 */
function ContactSearch(props) {
	const onClick = () => {
		props.onSearchInput('');
		props.onReset();
	};

	const onChange = (e) => {
		const inputWord = e.target.value;
		props.onSearchInput(inputWord);
		const filteredContacts = searchContact(inputWord, props.contacts);
		props.onSearch(filteredContacts);
	};

	return (
		<Search>
			<SearchIconWrapper>
				<SearchIcon />
			</SearchIconWrapper>
			<StyledInputBase
				placeholder="Search…"
				value={props.searchInput}
				onChange={onChange}
				endAdornment={
					<Tooltip title="Clear">
						<IconButton onClick={onClick}>
							<CloseOutlinedIcon />
						</IconButton>
					</Tooltip>
				}
			/>
		</Search>
	);
}

ContactSearch.propTypes = {
	contacts: array.isRequired,
	searchInput: string.isRequired,
	onSearch: func.isRequired,
	onSearchInput: func.isRequired,
	onReset: func.isRequired,
};

export default ContactSearch;
